import { createFileRoute, Link } from '@tanstack/react-router'
import { equipment, useEquipment } from '@/equipment/api'
import EquipmentDetailsPage from '@/views/refrigerant/customer/equipment-details-page'
import { ThaloWebContextProvider } from '@/contexts/ThaloWebContext'

export const Route = createFileRoute(
  '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/equipment/$equipmentId/',
)({
  params: {
    parse: (rawParams) => ({ equipmentId: parseInt(rawParams.equipmentId) }),
  },
  validateSearch: (search: Record<string, unknown>) => ({
    onsite: search.onsite === 'true' || search.onsite === true,
  }),
  loader: ({ context: { queryClient }, params: { equipmentId } }) =>
    Promise.all([
      queryClient.ensureQueryData(equipment.detail(equipmentId)),
      queryClient.ensureQueryData(equipment.detail(equipmentId)._ctx.installations),
    ]),
  component: RouteComponent,
  beforeLoad: ({ search }) => ({
    removeContentPadding: true,
    hideFeedbackFooter: true,
    hideNavBar: (search as any)?.onsite === true || (search as any)?.onsite === 'true',
  }),
  staticData: {
    breadcrumb: Breadcrumb,
  },
})

function RouteComponent() {
  return (
    <ThaloWebContextProvider>
      <EquipmentDetailsPage />
    </ThaloWebContextProvider>
  )
}

function Breadcrumb() {
  const { equipmentId } = Route.useParams()
  const { data: equipmentData } = useEquipment(equipmentId)
  return (
    <Link to={Route.fullPath} params={Route.useParams()}>
      {equipmentData.name}
    </Link>
  )
}
